export default __webpack_public_path__ + "static/media/indicator-dot.b9fce7da.svg";